import styled from 'styled-components/macro';

export const MainWrapper = styled.main`
  width: inherit;
  display: inherit;
  margin-top: -${(props) => props.theme.spacing(10)};
`;
